import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthGate } from "./components/auth/AuthGate";
import { AppShell } from "./components/layout/AppShell";
import { ChallengePage } from "./pages/ChallengePage";
import { ExploreDetailPage } from "./pages/ExploreDetailPage";
import { ExplorePage } from "./pages/ExplorePage";
import { HistoryPage } from "./pages/HistoryPage";
import { HomePage } from "./pages/HomePage";
import { MainlineTaskPage } from "./pages/MainlineTaskPage";
import { ParentPage } from "./pages/ParentPage";
import { ProfileEditPage } from "./pages/ProfileEditPage";
import { ProfilePage } from "./pages/ProfilePage";
import { RoomPage } from "./pages/RoomPage";
import { SurprisePage } from "./pages/SurprisePage";
import { WorldPage } from "./pages/WorldPage";

export function App() {
  return <AuthGate><BrowserRouter basename={import.meta.env.BASE_URL}><Routes><Route element={<AppShell />}>
    <Route index element={<HomePage />} />
    <Route path="explore" element={<ExplorePage />} />
    <Route path="explore/item/:id" element={<ExploreDetailPage />} />
    <Route path="world" element={<WorldPage />} />
    <Route path="world/:subject/:level" element={<ChallengePage />} />
    <Route path="journey/:taskId" element={<MainlineTaskPage />} />
    <Route path="history" element={<HistoryPage />} />
    <Route path="room" element={<RoomPage />} />
    <Route path="surprise" element={<SurprisePage />} />
    <Route path="parent" element={<ParentPage />} />
    <Route path="me" element={<ProfilePage />} />
    <Route path="me/profile" element={<ProfileEditPage />} />
  </Route><Route path="*" element={<Navigate to="/" replace />} /></Routes></BrowserRouter></AuthGate>;
}